export interface DAWInfo {
  name: string;
  icon: {
    fallbackChar: string;
    bgColor: string;
    icon?: string; // Optional path to icon image
    logo?: string; // Optional path to logo image
  };
}

// Get logos from here: https://www.pngwing.com/en/search?q=garageband+logo

export const DAW = {
  'ableton-live': {
    name: 'Ableton Live',
    icon: {
      fallbackChar: 'A',
      bgColor: '#ff6600',
      icon: '/dawLogos/icon/Ableton_icon.png',
      logo: '/dawLogos/logo/Ableton_full.png',
    },
  },
  'fl-studio': {
    name: 'FL Studio',
    icon: {
      fallbackChar: 'F',
      bgColor: '#ff8800',
      icon: '/dawLogos/icon/FLStudio_icon.png',
      logo: '/dawLogos/logo/FLStudio_full.png',
    },
  },
  'logic-pro': {
    name: 'Logic Pro',
    icon: {
      fallbackChar: 'L',
      bgColor: '#000000',
      icon: '/dawLogos/icon/LogicPro_icon.png',
    },
  },
  'pro-tools': {
    name: 'Pro Tools',
    icon: {
      fallbackChar: 'P',
      bgColor: '#8b5cf6',
      icon: '/dawLogos/icon/ProTools_icon.png',
    },
  },
  cubase: {
    name: 'Cubase',
    icon: {
      fallbackChar: 'C',
      bgColor: '#ef4444',
      icon: '/dawLogos/icon/Cubase_icon.png',
    },
  },
  reaper: {
    name: 'Reaper',
    icon: {
      fallbackChar: 'R',
      bgColor: '#059669',
      icon: '/dawLogos/icon/Reaper_icon.png',
    },
  },
  'studio-one': {
    name: 'Studio One',
    icon: {
      fallbackChar: 'S',
      bgColor: '#3b82f6',
      icon: '/dawLogos/icon/StudioOne_icon.png',
    },
  },
  reason: {
    name: 'Reason',
    icon: {
      fallbackChar: 'R',
      bgColor: '#f59e0b',
      icon: '/dawLogos/icon/Reason_icon.png',
    },
  },
  // bitwig: {
  //   name: "Bitwig",
  //   icon: { fallbackChar: "B", bgColor: "#ec4899" },
  // },
  garageband: {
    name: 'GarageBand',
    icon: {
      fallbackChar: 'G',
      bgColor: '#10b981',
      icon: '/dawLogos/icon/GarageBand_icon.png',
    },
  },
  // nuendo: {
  //   name: "Nuendo",
  //   icon: { fallbackChar: "N", bgColor: "#6366f1" },
  // },
  // sonar: {
  //   name: "Sonar",
  //   icon: { fallbackChar: "S", bgColor: "#14b8a6" },
  // },
  // ardour: {
  //   name: "Ardour",
  //   icon: { fallbackChar: "A", bgColor: "#e11d48" },
  // },
  // audacity: {
  //   name: "Audacity",
  //   icon: { fallbackChar: "A", bgColor: "#0ea5e9" },
  // },
  stems: {
    name: 'Stems',
    icon: {
      fallbackChar: '♪',
      bgColor: '#64748b',
    },
  },
} as const;

// Export list version for iteration
export const DAWS: DAWInfo[] = Object.values(DAW);

// Export keys for TypeScript autocomplete
export type DAWKey = keyof typeof DAW;

// Helper function to get a DAW by key (fast O(1) lookup)
export const getDAW = (key: DAWKey): DAWInfo => DAW[key];

// Helper function to get DAWs for top banner (first 12)
export const getTopBannerDAWs = (): DAWInfo[] => DAWS.slice(0, 12);

// Helper function to get DAWs for bottom banner (remaining)
export const getBottomBannerDAWs = (): DAWInfo[] => DAWS.slice(12);

// Helper function to find a DAW by name (slower O(n) lookup)
export const findDAWByName = (name: string): DAWInfo | undefined =>
  DAWS.find((daw) => daw.name.toLowerCase() === name.toLowerCase());

// Helper function to find a DAW key by name
export const findDAWKeyByName = (name: string): DAWKey | undefined => {
  const entry = Object.entries(DAW).find(
    ([_, daw]) => daw.name.toLowerCase() === name.toLowerCase()
  );
  return entry ? (entry[0] as DAWKey) : undefined;
};

// Helper function to get the best image source for a DAW
export const getDAWImageSource = (
  daw: DAWInfo,
  useFullLogo: boolean = false
): string | null => {
  if (useFullLogo && daw.icon?.logo) return daw.icon.logo;
  if (daw.icon?.icon) return daw.icon.icon;
  return null;
};

// Helper function to get popular DAWs (can be customized)
export const getPopularDAWs = (): DAWInfo[] => [
  DAW['ableton-live'],
  DAW['fl-studio'],
  DAW['logic-pro'],
  DAW['pro-tools'],
  DAW['cubase'],
  DAW['reaper'],
];
